import { IRoutine, ShowDetailsRight } from '../../_Common/Const/Delsystem';
import { rutinInfos } from '../../_Common/Const/RutinInfo';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const BJRutiner: { [rtnKey: string]: IRoutine } = {
  rtnBisattningsjournal: {
    component: getStandardRutin(
      rutinInfos.rtnBisattningsjournal,
      'BOBisattning'
    ),
    //detaljVy: 'bisattning',
    unusedRoutineMenuButtons: ['add'],
  },
  rtnWebBisattningsAktAvlidna: {
    component: getStandardRutin(
      rutinInfos.rtnWebBisattningsAktAvlidna,
      'BOBisattning'
    ),
    detaljVy: 'AktuellaAvlidna',
    config: {
      BOBisattning: {
        defaultColumns: [
          { attributeDef: 'Avlidna.Person.PERS_NR', caption: 'PersNr' },
          { attributeDef: 'AKTNUMMER', caption: 'Aktnr' },
          { attributeDef: 'Avlidna.Person.FORNAMN', caption: 'Förnamn' },
          { attributeDef: 'Avlidna.Person.EFTERNAMN', caption: 'Efternamn' },
          {
            attributeDef: 'SenasteHandelse.Bisattningstyp.BENAMNING',
            caption: 'Typ',
          },
          { attributeDef: 'SenasteHandelse._typ', caption: 'Status' },
          {
            attributeDef: 'SenasteHandelse.DATUM',
            caption: 'Senaste händelsen',
          },
          {
            attributeDef: 'SenasteHandelse.PLACERING_EJ_MALL',
            caption: 'Placering',
          },
          { attributeDef: 'TYP_URNA', caption: 'Typ av urna' },
          {
            attributeDef: 'Begravningsbyra.ORG_NAMN',
            caption: 'Begravningsbyrå',
          },
          {
            attributeDef: 'SenasteHandelse.TRANSPORTOR',
            caption: 'Senaste transportör',
          },
        ],
        defaultSort: [
          { attributeName: 'Avlidna.person.PERS_NR', order: 'asc' },
        ],
        userDeleteable: false,
      },
    },
    defaultShowDetailsRight: ShowDetailsRight.DefaultTrue,
    showDetailsRightSize: '400px',
    directEditMode: false,
    initialUrval: 'NOZgJlfVGOsyyvmUjGXTLVsmciCgdnhn', // 'Aktuella avlidna'  make_id(dbname:"_", collname:"_SELECTION", key:"417417417"){id}
    defaultVisningsTyp: 'tabell',
    defaultVisningsTypShowDetailsRight: 'kort',
    //filterAttributes: [{ attribute: 'Avliden.PERS_NR', label: 'PersNr' }],
    optInDataRefreshDesktop: true,
    optInDataRefreshMobile: true,
    unusedRoutineMenuButtons: ['add', 'urval', 'column'],
  },
  rtnWebBisattningsjournal: {
    component: getStandardRutin(
      rutinInfos.rtnWebBisattningsjournal,
      'BOBisattningshandelse',
      undefined,
      undefined
    ),
    defaultVisningsTyp: 'bisattningStart',
    hideRutinCollectionMenu: true,
  },
};

export default BJRutiner;
